import * as Dialog from '@radix-ui/react-dialog';
import { ComponentType, PropsWithChildren } from 'react';

import { Button } from './components/button/button';
import { Link } from './components/link/link';
import { Locations, type LocationsProps } from './components/locations/locations';
import styles from './side-navigation.module.css';
import { useBottomNavigation } from '../../bottom-navigation.context';
import { Close } from '../close';
import { Link as BottomNavigationLink } from '../link/link';
import { Logo, type LogoProps } from '../logo/logo';

type SideNavigationComposition = {
  Button: typeof Button;
  Link: typeof Link;
};

type SideNavigationProps = PropsWithChildren<LocationsProps & LogoProps>;
export const SideNavigation = (({ children, countries, logo }: SideNavigationProps) => {
  const { locations: title, more } = useBottomNavigation().content;

  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <BottomNavigationLink icon="more">{more}</BottomNavigationLink>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.sideNavigationOverlay} />
        <Dialog.Content className={styles.sideNavigation}>
          <header className={styles.header}>
            <Logo logo={logo} />

            <Dialog.Close className={styles.closeButton}>
              <Close />
            </Dialog.Close>
          </header>

          <Dialog.Title className={styles.title}>{title}</Dialog.Title>
          <Dialog.Description> </Dialog.Description>

          <Locations countries={countries} />

          {children && <div className={styles.links}>{children}</div>}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}) as ComponentType<SideNavigationProps> & SideNavigationComposition;
SideNavigation.Button = Button;
SideNavigation.Link = Link;
